import { IStoreStatistic, VideoRanking, AppLanguage } from 'AppTypes'
import { formatNumber, convertIntegerToOrdinalNumber } from '@utils/number'

export class StoreStatistic implements IStoreStatistic {
  totalFavorites: number

  favoritesLastWeekChanged: number

  last30DaysVisited: number

  visitedLastMonthChanged: number

  revenueRank: number

  revenueLastMonthChanged: number

  totalStoreRank: number

  maleProportion: number

  femaleProportion: number

  averageSales: number

  averageVideos: number

  order: number

  delivery: number

  takeOut: number

  overallVideoRanking: VideoRanking[]

  sameCategoryVideoRanking: VideoRanking[]

  constructor (storeStatistic: IStoreStatistic) {
    this.totalFavorites = storeStatistic.totalFavorites
    this.favoritesLastWeekChanged = storeStatistic.favoritesLastWeekChanged
    this.last30DaysVisited = storeStatistic.last30DaysVisited
    this.visitedLastMonthChanged = storeStatistic.visitedLastMonthChanged
    this.revenueRank = storeStatistic.revenueRank
    this.revenueLastMonthChanged = storeStatistic.revenueLastMonthChanged
    this.totalStoreRank = storeStatistic.totalStoreRank
    this.maleProportion = storeStatistic.maleProportion
    this.femaleProportion = storeStatistic.femaleProportion
    this.averageSales = storeStatistic.averageSales
    this.averageVideos = storeStatistic.averageVideos
    this.order = storeStatistic.order
    this.delivery = storeStatistic.delivery
    this.takeOut = storeStatistic.takeOut
    this.overallVideoRanking = storeStatistic.overallVideoRanking
    this.sameCategoryVideoRanking = storeStatistic.sameCategoryVideoRanking
  }

  getTotalFollowers (appLanguage: AppLanguage = 'jp'): string {
    const number = this.totalFavorites || 0
    return formatNumber(number, appLanguage)
  }

  getFollowersLastWeekChanged (appLanguage: AppLanguage = 'jp'): string {
    const number = this.favoritesLastWeekChanged || 0
    let direction = ''
    if (this.favoritesLastWeekChanged > 0)
      direction = '↑'
    if (this.favoritesLastWeekChanged < 0)
      direction = '↓'
    return `${formatNumber(number, appLanguage)}${direction}`
  }

  getLast30DaysVisitorsNumber (appLanguage: AppLanguage = 'jp'): string {
    const number = this.last30DaysVisited || 0
    return formatNumber(number, appLanguage)
  }

  getVisitorsLast30DaysChanged (appLanguage: AppLanguage = 'jp'): string {
    const number = this.visitedLastMonthChanged || 0
    let direction = ''
    if (this.visitedLastMonthChanged > 0)
      direction = '↑'
    if (this.visitedLastMonthChanged < 0)
      direction = '↓'
    return `${formatNumber(number, appLanguage)}${direction}`
  }

  getSalesRanking (appLanguage: AppLanguage = 'jp'): string {
    const number = this.revenueRank || ''
    return convertIntegerToOrdinalNumber(number, appLanguage)
  }

  getSameCategoryStoresNumber (appLanguage: AppLanguage = 'jp'): string {
    const number = this.totalStoreRank || 0
    return formatNumber(number, appLanguage)
  }

  getAverageSalesPrice (appLanguage: AppLanguage = 'jp'): string {
    if (!this.averageSales) return 'n/a'
    const number = this.averageSales
    return formatNumber(number, appLanguage)
  }

  getAveragePublicVideo (appLanguage: AppLanguage = 'jp'): string {
    if (!this.averageVideos) return 'n/a'
    const number = this.averageVideos
    return formatNumber(number, appLanguage)
  }

  getReserveNumber (appLanguage: AppLanguage = 'jp'): string {
    const number = this.averageVideos || 0
    return formatNumber(number, appLanguage)
  }

  getDeliveryNumber (appLanguage: AppLanguage = 'jp'): string {
    const number = this.delivery || 0
    return formatNumber(number, appLanguage)
  }

  getTakeOutNumber (appLanguage: AppLanguage = 'jp'): string {
    const number = this.takeOut || 0
    return formatNumber(number, appLanguage)
  }
}
